// extracted by mini-css-extract-plugin
module.exports = {"root":"Code_root__3yk3V","font":"Code_font__1OvX3"};